// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseRestQueryResult as baseQuery, showNotification } from "@/services/api";
import { Permissions, Permission } from "@/types/permission.type";

// Define a service using a base URL and expected endpoints
export const permissionApi = createApi({
  reducerPath: "permissionApi",
  baseQuery,
  endpoints: (builder) => ({
    getPermissions: builder.query<Permissions[], void>({
      query: () => "/permission",
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: {data: Permissions[]}, meta) => {
        return rawResult.data
      },
    }),
    updatePermission: builder.mutation<any, {permissions: Permission[]}>({
      query: (body) => ({
        url: '/permission',
        method: 'PUT',
        body,
      }),
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("PUT", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("PUT", "error", err?.error?.data?.message || "error")
        }
      }
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPermissionsQuery, useUpdatePermissionMutation } = permissionApi;
